// منابع ترجمه: src/locales/{lang}/{namespace}.json — یک فضای نام به ازای ماژول (کد کوچک ماژول) به‌اضافه
// common (اجزای مشترک ui)، shell (پوسته اپ‌ها)، auth (ورود، انتخاب مستأجر، قفل) و errors (تولیدی از سرور).
import type { Resource, ResourceLanguage } from 'i18next';

export const NAMESPACES = [
  'common',
  'shell',
  'auth',
  'errors',
  'iam',
  'plt',
  'cfg',
  'int',
  'console',
  'org',
  'cat',
  'pat',
  'sch',
  'chn',
  'msg',
  'doc',
  'bil',
  'acc',
  'cln',
  'inv',
  'med',
  'cmp',
  'ins',
  'eng',
  // AP-TEL-01: ویزیت آنلاین (میز کار، پایش اتاق انتظار و پرتال).
  'tel',
  // AP-CHN-01: پرتال مراجعه‌کنندگان (apps/portal) و صفحه عمومی و ویجت (apps/public).
  'portal',
  'public',
] as const;
export type Namespace = (typeof NAMESPACES)[number];

const files = import.meta.glob<Record<string, unknown>>('./locales/*/*.json', {
  eager: true,
  import: 'default',
});

function build(): Resource {
  const result: Resource = {};
  for (const [path, content] of Object.entries(files)) {
    const match = /\.\/locales\/([^/]+)\/([^/]+)\.json$/.exec(path);
    if (!match) {
      continue;
    }
    const [, language, namespace] = match as unknown as [string, string, string];
    const languageResources: ResourceLanguage = result[language] ?? {};
    languageResources[namespace] = content as ResourceLanguage[string];
    result[language] = languageResources;
  }
  return result;
}

export const resources: Resource = build();
